import React, {useEffect, useState} from 'react';
// @ts-ignore
import {EventSourcePolyfill} from 'event-source-polyfill';

import {User} from '../_services/User';
import {Modal} from './Modal';

type ExportEntriesModalProps = {
    close: () => void;
    errorMessage: string;
    exportId: string;
};

export const ExportEntriesModal: React.FunctionComponent<ExportEntriesModalProps> = ({
                                                                                         close,
                                                                                         exportId,
                                                                                         errorMessage,
                                                                                     }): JSX.Element => {
    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [isRunning, setIsRunning] = useState<boolean>(true);
    const [localErrorMessage, setLocalErrorMessage] = useState<string>('');
    const [statusMessage, setStatusMessage] = useState<string>('');

    useEffect(() => {
        if (!exportId) return;

        const es = new EventSourcePolyfill('/p/flow/api/export-status/' + exportId, {
            headers: {
                'Authorization': 'Bearer ' + User.getInstance().getAuthToken()
            }
        });
        es.onmessage = function (event: any) {
            console.log(event.data);
            if (event.data === 'Done') {
                setIsRunning(false);
                setIsComplete(true);
                setStatusMessage('');
            } else {
                if (event.data.match(/^Error /)) {
                    setLocalErrorMessage(event.data);
                    setStatusMessage('');
                    setIsRunning(false);
                    setIsComplete(false);
                } else {
                    setStatusMessage(event.data);
                }
            }
        };

        return () => {
            es.close();
        };
    }, [exportId]);

    useEffect(() => {
        setLocalErrorMessage(errorMessage);
    }, [errorMessage]);

    return (
        <Modal>
            <div className="modal-header">
                <h5 className="modal-title">Exporting Entries</h5>
                <button type="button"
                        className="close"
                        aria-label="Close"
                        tabIndex={-1}
                        onClick={() => {
                            close && close();
                        }}
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="container">
                    <div className="row mb-2">
                        <div className="col">
                            {isComplete &&
                            <div>
                                <p>Export complete. Download by clicking the link below.</p>
                                <p><a href={`/p/flow/api/download-export-file/${exportId}`}>Download File</a></p>
                            </div>
                            }
                            {isRunning &&
                            <div className="d-flex">
                                <div><i className="fas fa-spinner fa-spin"/></div>
                                <span className="ml-2 flex-grow-1">Please wait, export is running. Once complete the link to download will appear.</span>
                            </div>
                            }
                            {statusMessage && <p className="text-info">{statusMessage}</p>}
                            {localErrorMessage && <p className="text-danger">{localErrorMessage}</p>}
                        </div>
                    </div>
                </div>
            </div>
            {isComplete &&
            <div className="modal-footer">
                <button type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            close && close();
                        }}
                >Close
                </button>
            </div>
            }
        </Modal>
    )
};